<template>
  <div>
    <v-card :class="totop" :loading="loading" flat class="max-height">
      <div class="float-left width-full">
        <div class="width-full">
          <div class="chart-title float-left">
            <v-icon>playlist_add_check</v-icon>Check List
          </div>
          <div v-if="editable" class="settings-button">
            <v-btn v-if="!edit" icon class="my-0" @click="dialog ? dialog = false : dialog = true">
              <v-icon size="22" color="#808F9C">add_circle_outline</v-icon>
            </v-btn>
            <v-btn icon class="my-0" @click="edit ? edit = false : edit = true">
              <v-icon size="18" color="#808F9C">edit</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="pa-0 width-full float-left font-small">
          <!--
          <v-chip
            class="mr-2 pointer"
            v-for="tag in value"
            :key="tag"
            color="#4dbac0"
            @click="routerToTag(tag._id)"
          >{{tag.name}}</v-chip>
          -->

          <v-data-table
            :headers="headers"
            :items="checklistData"
            item-key="name"
            class="elevation-1 checklist"
          >
          
            <template v-slot:item.name="{ item }">
              <v-chip
                :close="edit"
                @click:close="removeObject(item.id)"
                color="#4dbac0"
                class="float-left"
              >{{item.name}}</v-chip>
            </template>

            <template v-slot:item.equity="{ item }">
                <div class="pa-2">
                  <v-sparkline
                    height="80px"
                    :value="item.equity"
                    :color="item.result > 0 ? '#79C04D': (item.result < 0 ?'#E62163' : '#808F9C')"
                    line-width="10"
                    smooth="10"
                    padding="0"
                  ></v-sparkline>
                </div>
              </template>

            <template v-if="!edit" v-slot:item.result="{ item }">
              <div>
                <v-btn
          x-small
          class="roboto-condensed"
          style="font-size: 12px"
          :color="item.result > 0 ? '#79C04D': (item.result < 0 ?'#E62163' : '#808F9C')"
        >${{item.result}}</v-btn>
                
              </div>
            </template>

            <template v-if="!edit" v-slot:item.pst="{ item }">
              <span class="roboto-condensed">
                {{item.pst}}
              </span>
            </template>

            <template v-if="!edit" v-slot:item.occurr="{ item }">
              <span class="roboto-condensed">
                {{item.occurr}}
              </span>
            </template>

            <template v-if="!edit" v-slot:item.action="{ item }">
              <div>
                <v-btn @click="routerMethod(item._id)" text icon color="white">
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </div>
    </v-card>
    <div :class="dimmer" @click="edit = false"></div>

    <v-dialog max-width="500px" v-model="dialog" transition="dialog-bottom-transition">
      <v-card :loading="loading" ref="form">
        <v-card-title>
          <span class="headline">Add Tag to Checklist</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  deletable-chips
                  v-model="selected"
                  :items="filteredTags"
                  itemText="name"
                  label="Select Tag..."
                  color="#4dbac0"
                  autocomplete="off"
                  return-object
                  chips
                  multiple
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false" text>Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="addObject">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "CheckList",
  props: {
    value: Array,
    data: Object,
    parentType: String,
    storeKey: String,
    editable: Boolean
  },
  data() {
    return {
      checklistData: [],
      selected: null,
      dialog: false,
      dialogLoading: false,
      loading: false,
      edit: false,
      totop: "totop-off",
      dimmer: "dimmer-off",
      newDesc: this.value,
      type: "",
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "PL",
          align: "right",
          sortable: true,
          value: "result"
        },
        {
          text: "Win%",
          align: "right",
          sortable: true,
          value: "pst"
        },
        {
          text: "Ocr%",
          align: "right",
          sortable: true,
          value: "occurr"
        },
        {
          text: "Equity",
          align: "right",
          sortable: true,
          value: "equity"
        },

        { text: "", value: "action", sortable: false, align: "center" }
      ]
    };
  },
  watch: {
    edit: function(newVal) {
      if (newVal === true) {
        this.totop = "totop";
        this.dimmer = "dimmer";
        //this.headers[4].text = "Delete"
      } else {
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
        //his.headers[4].text = ""
      }
    },
    dialog: function(newVal) {
      // tags list
      if (newVal == true) {
        var apiData = {
          action: "REQUEST",
          component: "Tags",
          document: "Tags",
          method: "list"
        };
        this.API(apiData);
      }
    },
    data: function() {
      this.recalc();
    },
    value: function(){
      this.recalc();
    }
  },
  computed: {
    ...mapGetters(["Tags"]),

    filteredTags() {
      var filteredList = this.tags;
 
      this.value.forEach(element => {
        this.tags.forEach((tag, index) => {
          if (element.name == tag.name) {
            filteredList.splice(index, 1);
          }
        });
      });
    

      return filteredList;
    }
  },
  asyncComputed: {
    tags: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/tags/", {
              method: "listBasic",
              user: this.$route.params.name
            })
            .then(response => {
              // setTimeout(() => {
              this.loaded = true;
              resolve(response.data);
              // },1000)
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    }
  },
  mounted() {
    this.recalc();
  },
  methods: {
    routerToTag(id) {
      return this.$router.push({
        name: "tags",
        params: { id: id }
      });
    },
    removeObject(id) {
      //this.$emit('updateDescription', this.value)

      this.loading = true;

      axios
        .post("https://tradeinpool.com:3001/api/update/strategies/", {
          documentId: id,
          parentDocument: this.parentType,
          parentId: this.$route.params.id,
          key: "active",
          newValue: false,
          type: "deleteCheckList"
        })
        .then(response => {
          this.loading = false;
          this.$emit("removeChecklist", response.data);
        })
        .catch(err => {
          alert(err);
          this.loading = false;
        });
    },
    addObject() {
      this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/update/strategies/", {
          data: this.selected,
          type: "addCheckList",
          parentId: this.$route.params.id
        })
        .then(response => {
          this.loading = false;
          this.edit = false;
          (this.selected = null), this.$emit("update", response.data.push);
        })
        .catch(err => {
          alert(err);
          this.loading = false;
        });
      this.dialog = false;
    },
    recalc() {
      this.checklistData = []
      if (this.data.hasOwnProperty("_checkList")) {
        this.data._checkList.forEach(item => {
          var pushObj = {
            name: null,
            pls: [],
            not: [],
            id: null,
            trades: 0,
            pst: 0,
            equity: [0],
            profits: 0,
            losts: 0,
            traded: 0,
            result: null,
            occurr: 0,
          };
          pushObj.name = item.name;
          pushObj.id = item._id;

          var tradesReversed = []
          
          this.data._trades.forEach(tr =>{
            tradesReversed.push(tr)
          })


          tradesReversed.reverse().forEach(trade => {
            if (trade.hasOwnProperty("_prepare")) {
            if (trade._prepare) {
              if (trade._prepare.checklist) {
                trade._prepare.checklist.forEach(chck => {
                  if (item.name == chck.name) {
                    //alert(trade.ClosedProfitLoss)
                    pushObj.trades = pushObj.trades + 1;
                    if (chck.selected == true) {
                      pushObj.traded = pushObj.traded + 1;
                      if (trade.ClosedProfitLoss > 0)
                        pushObj.profits = pushObj.profits + 1;
                      else pushObj.losts = pushObj.losts + 1;

                      pushObj.pls.push(trade.ClosedProfitLoss);
                      pushObj.equity.push(
                        pushObj.equity[pushObj.equity.length - 1] +
                          trade.ClosedProfitLoss
                      );
                    } else pushObj.not.push(trade.ClosedProfitLoss);
                  }
                });
              }
            }
            }
          });
          pushObj.pst = (pushObj.profits/pushObj.traded*100).toFixed(0)
          pushObj.occurr = (pushObj.traded/pushObj.trades*100).toFixed(0)
          pushObj.result = (pushObj.equity[pushObj.equity.length -1]).toFixed(0)
          this.checklistData.push(pushObj);
        });
      }
    }
  }
};
</script>

<style>
</style>